import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import CenteredMainContainer from "./CenteredMainContainer";
import FlexContainer from "./FlexContainer";
import FlexCenteringSpacer from "./FlexCenteringSpacer";
import SideNavContainer from "./SideNavContainer";
import ResponsiveFlexContainer from "./ResponsiveFlexContainer";

import theme from "../../styles/theme";

// mimics a conventional twitterbootstrap container
const StyledContainer = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  /* only add set widths if container is NOT fluid */
  ${({ fluid }) =>
    !fluid &&
    css`
      padding-right: 15px;
      padding-left: 15px;
      ${() => theme.media.tabletUp`
        width: 750px;
      `};
      ${() => theme.media.desktopUp`
        width: 970px;
      `};
      ${() => theme.media.wideScreenUp`
        width: 1170px;
      `};
    `}
`;

const Container = ({ children, className, fluid }) => {
  return (
    <StyledContainer className={className} fluid={fluid}>
      {children}
    </StyledContainer>
  );
};

Container.propTypes = {
  children: PropTypes.node.isRequired
};

export default Container;

export {
  CenteredMainContainer,
  FlexContainer,
  SideNavContainer,
  FlexCenteringSpacer,
  ResponsiveFlexContainer
};
